<template>
  <v-flex class="mt-5">
    <table-layout>
      <template v-slot:title>
        대출모집 수수료 조견표(
        <span v-if="!isModify">{{ setDashDate(feeData.baseYmd) }}</span>
        <v-text-field
           v-if="isModify"
          v-model="modifiedData.baseYmd"
          placeholder="기준일자를 입력해주세요"
          outlined hide-details dense
          background-color="white"
           class="base-date-format"
        />
        기준)
      </template>
      <template v-slot:button>
        <v-btn v-if="!isModify && isAdmin" class="button" outlined @click="isShowModify">
          업데이트
        </v-btn>
        <div class="buttons-layout" v-if="isModify">
          <v-btn class="button" outlined @click="isModifyData">
            수정
          </v-btn>
          <v-btn class="button delete" outlined @click="isCloseModify">취소</v-btn>
        </div>
      </template>
      <template v-slot:table>
        <commission-condition-table
          :fee-data="feeData"
          :is-modify="isModify"
          @modifyData="modifyData"
        />
      </template>
    </table-layout>
  </v-flex>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import CommissionConditionTable from "@/pages/Loan/components/CommissionCalculation/CommisstionConditionTable.vue";
import {axiosInstance} from "@/util/AxiosModule";
import DateMixin from "@/mixin/DateMixin";
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
  name: "CommissionCalculationTable",
  components: {CommissionConditionTable, TableLayout},
  mixins: [DateMixin],
  data() {
    return {
      feeData: {},
      isModify: false,
      modifiedData: {}
    }
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole",
      memberId: "memberId"
    }),
    isAdmin() {
      return this.memberRole === "ADMIN";
    }
  },
  mounted() {
    this.getFeeList();
  },
  methods: {
    async getFeeList() {
      try {
        const { data } = await axiosInstance.get("/private/operation/fee");
        this.feeData = data;
        this.$emit("feeData", data);
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    isShowModify() {
      this.isModify = true;
    },
    modifyData(data) {
      this.modifiedData = data;
    },
    isModifyData() {
      this.showConfirm({
        message: "수정내용을 저장하시겠습니까?",
        successCallback: () => {
          this.modified();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async modified() {
      let feeDto = _.cloneDeep(this.modifiedData);
      feeDto["createId"] = this.memberId;
      Object.keys(feeDto)
          .filter(key => key !== "baseYmd" && key !== "createId" && isNaN(feeDto[key]) === false && typeof feeDto[key] !== 'number')
          .forEach(key => {feeDto[key] = Number(feeDto[key])});
      await axiosInstance.put("/admin/operation/fee", feeDto)
          .then(() => {
            this.showAlert({
              message: "수정이 완료되었습니다.",
              successCallback: () => {
                this.modifiedData = {};
                this.getFeeList();
                this.isModify = false;
              }
            })
          }).catch((error) => {
            this.showAlert({message: `${error}`});
          })
    },
    isCloseModify() {
      this.showConfirm({
        message: "수정하셨던 내용이 모두 사라집니다. 수정을 취소하시겠습니까?",
        successCallback: () => {
          this.isModify = false;
        },
        failCallback: () => {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.base-date-format {
  display: inline-block;
  font-size: 18px;
  max-width: 120px;
}
</style>